import { Component, Input, Output, EventEmitter } from "@angular/core"
import { MediaQueryService } from "src/services/media-query-service"

@Component({
  selector: 'ad-banner',
  styleUrls: ['./ad-banner.component.scss'],
  template:
  `
    <div class="main-container border border-solid border-light-gray">
      <div class="ad-banner-left text-center">
        <i class="icon font-size-36" [ngClass]="icon"></i>
      </div>
      <div class="ad-banner-middle border-left border-left-light-gray">
        <div class="px-3 py-2">
          <div [innerHTML]="mainTitle">
          </div>
          <div [innerHTML]="subtitle">
          </div>
        </div>
      </div>
      <div class="ad-banner-right text-center">
        <button class="small-vertical-buffer no-vertical-buffer-md right-buffer-md btn btn-outline-primary biggish-text" (click)="onStartAction()" [disabled]="!buttonEnabled">{{actionButtonLabel}}</button>
      </div>
    </div>
  `
})
export class AdBanner {
  @Input() mainTitle: string;
  @Input() subtitle: string;
  @Input() actionButtonLabel: string = "let's go";
  @Input() icon: string;
  @Input() buttonEnabled: boolean = true;
  @Output() actionClick: EventEmitter<null> = new EventEmitter<null>();

  constructor(private mediaQuery: MediaQueryService) {}

  onStartAction(): void {
    this.actionClick.emit()
  }

  get isMobile(): boolean {
    return this.mediaQuery.isUnder('md')
  }
}
